import { getElementComputedDimensions } from '@utils/elements';

import { article, header } from './articleListedElements';

interface TargetTopScrollProps {
  chapterScrollOffset?: number;
}

const targetTopScroll = ({ chapterScrollOffset = 20 }: TargetTopScrollProps = {}): number => {
  const headerHeight = getElementComputedDimensions(header).height;

  return (
    article.getBoundingClientRect().top +
    document.documentElement.scrollTop -
    (headerHeight + chapterScrollOffset)
  );
};

export { targetTopScroll };
